import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function RouteProtegee({ children }) {
  const { estConnecte, chargement } = useAuth();
  const location = useLocation();

  if (chargement) {
    return (
      <div
        style={{
          minHeight: '100vh',
          background: 'var(--couleur-fond)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ color: 'rgba(255,255,255,0.2)', fontSize: '1.5rem', letterSpacing: '0.2em' }}>
          ···
        </div>
      </div>
    );
  }

  if (!estConnecte) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
